/**
 * Created by Mikhail Menshenin on 17.10.2024
 */

const VillageAttackResultView = cc.Node.extend({
    ctor: function (village) {
        this._super();

        const styles = cleverapps.styles.VillageAttackResultView;
        this.setAnchorPoint(0.5, 0.5);
        this.setContentSize(styles);

        const controlPanelBg = cleverapps.UI.createScale9Sprite(bundles.village.frames.control_panel_bg);
        controlPanelBg.setContentSize(styles);
        controlPanelBg.setPosition(this.width / 2, this.height / 2);
        this.addChild(controlPanelBg);

        const player = village.getPlayer();
        const playerLabel = cleverapps.UI.generateOnlyText(Messages.get(village.defended() ? "VillageAttackScene.defendedPlayerLabel" : "VillageAttackScene.attackedPlayerLabel"), cleverapps.styles.FONTS.DARK_TEXT);
        const playerName = cleverapps.UI.generateOnlyText(player.name, cleverapps.styles.FONTS.VILLAGE_ATTACK_PLAYER_NAME_TEXT);
        const playerNameLayout = new cleverapps.Layout([playerLabel, playerName], {
            direction: cleverapps.UI.HORIZONTAL,
            margin: styles.player.margin
        });
        playerNameLayout.setAlignment(styles.player);
        this.addChild(playerNameLayout);

        const rewardLabel = cleverapps.UI.generateOnlyText(Messages.get("VillageAttackScene.rewardLabel"), cleverapps.styles.FONTS.DARK_TEXT);
        const goldText = this.goldText = new TextWithIcon(`${aisensia.getNumberWithCommas(village.goldCollected)} ${TextWithIcon.ICONS_BY_NAME.hard}`, {
            font: cleverapps.styles.FONTS.VILLAGE_ATTACK_RESULT_TEXT
        });

        const rewardLayout = new cleverapps.Layout([rewardLabel, goldText], {
            direction: cleverapps.UI.HORIZONTAL,
            margin: styles.reward.margin
        });
        rewardLayout.setAlignment(styles.reward);
        this.addChild(rewardLayout);
    },

    show: function () {
        const position = this.getPosition();
        this.setPosition(position.x, position.y - this.height);
        this.runAction(new cc.Sequence(
            new cc.DelayTime(0.3),
            new cc.MoveBy(0.4, 0, this.height).easing(cc.easeOut(1))
        ));
        cleverapps.audio.playSound(bundles.main.urls.control_panel_bg);
    }
});

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    VILLAGE_ATTACK_PLAYER_NAME_TEXT: {
        size: 45,
        color: new cc.Color(244, 64, 166)
    },

    VILLAGE_ATTACK_RESULT_TEXT: {
        name: "default",
        size: 40,
        color: new cc.Color(0, 208, 5),
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE
    }
});

cleverapps.styles.VillageAttackResultView = {
    width: 766,
    height: 220,

    player: {
        margin: 8,

        x: { align: "center" },
        y: { align: "bottom", dy: 124 }
    },

    reward: {
        margin: 8,

        x: { align: "center" },
        y: { align: "bottom", dy: 54 }
    }
};